import React from 'react';
import PlayerSelectionPanelRedux from '../../containers/outputPlayer/PlayerSelectionPanel';
import { loadPlayer } from '../../helpers/tools';
import { EP_TITLE } from '../../constants/Labels';

class EmbeddedPlayer extends React.Component {
  render() {
    return (
      <div className="embeddedPlayer">
        <span className="outputPanelTitle">{EP_TITLE}</span>
        <PlayerSelectionPanelRedux />
        <div className="player-container-outer">
          <div className="player-container-inner">
            <div id={this.props.containerId}></div>
          </div>
        </div>
        {loadPlayer(
          this.props.name,
          this.props.version,
          this.props.containerId,
          this.props.autoplay
        )}
      </div>
    );
  }
}

export default EmbeddedPlayer;
